/// <reference types="@welldone-software/why-did-you-render" />
// uncomment below for an easy way to see components re-rendering that maybe shouldn't be
// can also put `Component.whyDidYouRender = true` to target specific components
// https://github.com/welldone-software/why-did-you-render

/*
import React from 'react';

if (process.env.NODE_ENV === 'development' || __DEV__) {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    //
    // the below notifier is better suited to running with with react-native (it is less verbose)
    // notifier: ({ nextHook, prevHook }) => {
    //   const prevProps = prevHook ? Object.keys(prevHook) : 'null';
    //   const nextProps = nextHook ? Object.keys(nextHook) : 'null';
    //   console.log(
    //     'PREV',
    //     prevProps.slice(0, 3),
    //     '...' + (prevProps.length - 2),
    //     'NEXT',
    //     nextProps.slice(0, 3),
    //     '...' + (nextProps.length - 2)
    //   );
    // },
    //
    // good way to keep an eye on the app as a whole...
    // trackAllPureComponents: true,
  });
}
*/

export {};
